let accessToken = null;

const authTokenStore = {
  setAccessToken: (token) => {
    accessToken = token || null;
  },
  getAccessToken: () => accessToken,
  clearAccessToken: () => {
    accessToken = null;
  },
};

export default authTokenStore;
